<template>
	<div class="flex items-start gap-2 pb-2">
		<div class="w-5 h-5 md:w-6 md:h-6 flex-none">
			<img
				class="w-5 h-5 md:w-6 md:h-6"
				src="/images/checkmark.svg"
				alt="Checkmark icon"
			/>
		</div>
		<p class="text-slate-300 text-sm md:text-base">
			<b class="text-white">{{ item.title }}:</b>
			{{ item.text }}
		</p>
	</div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
	item: Object
});
</script>
